import {
  LIBRARY_TAXES_PAGE_REQUEST,
  LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS,
  LIBRARY_TAXES_LIST_REQUEST,
  LIBRARY_TAXES_ON_CLICK_ROW,
  LIBRARY_TAXES_ON_CLICK_CANCEL,
  LIBRARY_TAXES_SUBMIT_FORM_UPDATE,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE,
  LIBRARY_TAXES_ON_CLICK_CREATE_TAX,
  LIBRARY_TAXES_DELETE_TAX_REQUEST,
  LIBRARY_TAXES_CANCEL_DELETE,
  LIBRARY_TAXES_DELETE_TAX,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS,

  LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST,
  LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM,
  LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE
} from 'actions/library/tax/constants'
import {takeLatest, put, call, takeEvery, select} from 'redux-saga/effects'
import {initialize, change} from 'redux-form'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as actTax from 'actions/library/tax'
import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiTax from 'api/taxes'
import * as apiItem from 'api/libraries/items'
import * as apiCategory from 'api/categories'
import * as apiSetting from 'api/settings'

import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpLibraryTax from 'mixpanel/library/tax'
import * as _ from 'lodash'
import { browserHistory } from 'react-router'

export function * onClickTaxAssignToItem (action) {
  let {payload: {tax, categoryId}} = action
  // set categoryId should be '' and not 0 for All Categories
  try {
    yield put(act.showProgressBar())
    // set apply item data
    const resItems2 = yield call(apiItem.getItems, { category_id: categoryId, inventory: 'all', keyword: '', page: 1 })
    let summary = yield call(apiItem.getSummary, { category_id: categoryId, inventory: 'all', keyword: '', page: 1 })
    const data = {
      results: resItems2.data,
      total_pages: summary.data.total_pages,
      total_count: summary.data.total_items
    }
    if (categoryId === '') { // change it to an integer
      categoryId = 0
    }
    yield put(change('taxAssignToItem', 'category_id', categoryId))
    yield put(actTax.taxAssignToItemFillForm(tax, categoryId))
    yield put(actTax.taxAssignToItemSetCurrentPage(1))
    yield put(actTax.taxAssignToItemSetTotalPage(data.total_pages))
    yield put(actTax.taxAssignToItemSetItems(data.results))
    yield put(actTax.taxAssignToItemSetTotalCount(data.total_count)) // for total_count
    yield put(actTax.showTaxAssignToItemModal()) // showApplySetItem
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

function * taxAssignToItemFillFormFlow (request) { // IMPORTANT - Fill Map Here
  const {payload: { tax, categoryId }} = request
  let taxDetail = tax.taxDetail
  let form = {
    id: 0,
    itemIds: [], // item tax mapping to ids on the form...
    category_id: categoryId
  }
  if (taxDetail !== null) {
    form = {
      id: taxDetail.id,
      category_id: categoryId,
      itemIds: taxDetail.items.map((itemTax) => itemTax.item_id) // item tax mapping to ids on the form...
    }
  }
  yield put(initialize('taxAssignToItem', form))
}

export function * taxAssignToItemToggleOne (request) {
  const {taxDetail, item, add} = request.payload
  const itemId = item.id
  const itemName = item.name
  const categoryId = item.category_id
  if (taxDetail === null) {
    // Should Not Get Here
  } else {
    if (add === true) { // add to taxDetail.items - no need to sort
      taxDetail.items.push({
        item_id: itemId,
        category_id: categoryId,
        name: itemName
      })
    } else { // remove from taxDetail.items
      for (var i = 0; i < taxDetail.items.length; i++) {
        if (taxDetail.items[i].item_id === itemId) {
          taxDetail.items.splice(i, 1)
          break
        }
      }
    }
    yield put(actTax.setTaxDetail(taxDetail))
  }
}

export function * taxAssignToItemSelectAllNone (request) {  // IMPORTANT - Update Map Here
  try {
    yield put(act.showProgressBar())
    const {payload: {taxDetail, categoryId, keyword, selectAll}} = request
    // get IDs from backend
    let _categoryId = categoryId === 0 ? '' : categoryId
    let name = keyword === undefined ? '' : keyword

    let response = yield call(apiTax.filterTaxItem, _categoryId, name)
    let taxData = response.data
    let theItems = taxData.map(item => {
      return { item_id: item.id, category_id: item.category_id, name: item.name }
    })
    let form = { // update form also...
      category_id: categoryId,
      keyword: keyword
    }
    if (taxDetail === null) {
      // Should Not Get Here
    } else {
      if (selectAll === true) { // Add & Merge
        taxDetail.items = _.unionBy(taxDetail.items, theItems, 'item_id')
      } else { // Remove
        taxDetail.items = _.xorBy(taxDetail.items, _.intersectionBy(taxDetail.items, theItems, 'item_id'), 'item_id') // or pull all by
      }
      yield put(actTax.setTaxDetail(taxDetail))
      form.id = taxDetail.id
      form.itemIds = taxDetail.items.map((itemTax) => itemTax.item_id)
    }
    if (taxDetail.id === null) {
      mpLibraryTax.libraryTaxCreateAssignItemAssignAll(taxDetail, categoryId, keyword)
    } else {
      mpLibraryTax.libraryTaxEditAssignItemAssignAll(taxDetail, categoryId, keyword)
    }
    // yield put(initialize('taxAssignToItem', form)) // Update The Form Here
    yield put(change('taxAssignToItem', 'itemIds', form.itemIds))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * taxAssignToItemItemsRequest (request) { // applySetItemItemsRequest
  const {payload: {params, previousItems}} = request
  try {
    yield put(act.showProgressBar())
    let categoryId = (params.categoryId === 0) ? '' : params.categoryId
    const resItems2 = yield call(apiItem.getItems, { no_categories: true, category_id: categoryId, inventory: 'all', keyword: params.keyword, page: params.page })
    let summary = yield call(apiItem.getSummary, { no_categories: true, category_id: categoryId, inventory: 'all', keyword: params.keyword, page: params.page })
    const data = {
      results: resItems2.data,
      total_pages: summary.data.total_pages,
      total_count: summary.data.total_items
    }
    yield put(actTax.taxAssignToItemSetCurrentPage(params.page))
    yield put(actTax.taxAssignToItemSetTotalPage(data.total_pages))
    yield put(actTax.taxAssignToItemSetTotalCount(data.total_count)) // for total_count
    let items = previousItems.concat(data.results)
    yield put(actTax.taxAssignToItemSetItems(items))
    const itemsAsId = _.without(_.map(items, 'id'), undefined)
    const intersect = _.intersection(itemsAsId, params.itemIds)
    if (intersect.length === itemsAsId.length && itemsAsId.length !== 0) {
      yield put(actTax.checkSelectAllTaxItems())
    } else {
      yield put(actTax.uncheckSelectAllTaxItems())
    }

    yield put(actTax.showTaxAssignToItemModal())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * cancelTaxAssignToItem (request) {
  let { taxDetail, url } = request.payload
  let form = {
    category_id: '', // like initialize
    keyword: ''
  }

  if (taxDetail === null) {
    // Should Not Get Here
  } else {
    taxDetail.items = taxDetail.org_items.filter(item => true)
    yield put(actTax.setTaxDetail(taxDetail))
    form.id = taxDetail.id
    form.itemIds = taxDetail.items.map((itemTax) => itemTax.item_id) // item tax mapping to ids on the form...
  }
  yield put(initialize('taxAssignToItem', form, false)) // Update The Form Here
  // yield put(reset('taxAssignToItem')) // Update The Form Here
  // yield put(reset('tax'))
  yield put(actTax.hideTaxAssignToItemModal())
  if (url) {
    // onClickCancelFlow()
    browserHistory.push(url)
  }
}

export function * confirmTaxAssignToItem (request) {
  let { taxDetail, tax } = request.payload
  if (taxDetail === null) {
    // Should Not Get Here
  } else {
    taxDetail.org_items = taxDetail.items.filter(item => true)
    yield put(actTax.setTaxDetail(taxDetail)) // original names, but with updated items (need to do here because it involves item_id and category_id )
    taxDetail.name = tax.values.name // save form name & amount
    taxDetail.amount = tax.values.amount
    taxDetail.custom_amount_flag = tax.values.custom_amount_flag
    taxDetail.custom_amount_item = tax.values.custom_amount_item
    yield call(fillFormTaxDetail, taxDetail)
  }
  yield put(actTax.hideTaxAssignToItemModal())
}

function * fillSearchFormFromProfile (profile) {
  let assignedOutletIds = []
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {'outletIds': assignedOutletIds}
  yield put(initialize('search', data))
}

function * fillFormTaxDetail (tax) {
  let formTaxDetail = {
    id: tax.id,
    name: tax.name,
    amount: tax.amount ? tax.amount.toString() : tax.amount,
    item_ids: [],
    custom_amount_flag: tax.custom_amount_flag,
    custom_amount_item: tax.custom_amount_item
  }
  yield put(initialize('tax', formTaxDetail))
}

function * openRightColumn () {
  yield put(actTax.openRightColumn())
}

function * closeRightColumn () {
  yield put(actTax.closeRightColumn())
}

export function * taxesPageRequestFlow () {
  yield put(actTax.setListTaxes([]))
  yield put(showPageLoadingSpinner(true))
  yield put(actTax.setTaxDetail(null))
  yield put(actTax.setOutlets([]))
  yield call(closeRightColumn)

  yield put(act.showProgressBar())
  try {
    let response = yield call(apiOutlets.outlets)
    yield put(actTax.setOutlets(response.data))

    let resSetting = yield call(apiSetting.getSettings)
    yield put(actTax.setSetting(resSetting.data[0]))

    let resProfile = yield call(apiProfile.getProfile)
    mpLibraryTax.libraryTaxStart({currOutlet: resProfile.data.outlet_id[0]})
    yield call(fillSearchFormFromProfile, resProfile.data)

    const categoriesRes = yield call(apiCategory.getCategoriesWithUncategorizedV1)
    yield put(actTax.setCategories(categoriesRes.data))

    let resTaxes = yield call(apiTax.getTaxService, {page: 0}) // resProfile.data.business.id, resProfile.data.outlet_id[0]
    let taxes = resTaxes.data.content
    yield put(actTax.setListTaxes(taxes))
    yield put(actTax.setTotalPage(resTaxes.data.total_pages))
    yield put(actTax.setCurrentPage(0))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * taxesRequestFlow (action) {
  let {payload: {params, previousTaxes}} = action
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiTax.getTaxService, params)
    let taxes = previousTaxes.concat(response.data.content)
    yield put(actTax.setListTaxes(taxes))
    yield put(actTax.setTotalPage(response.data.total_pages))
    yield put(actTax.setCurrentPage(params.page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * onChangeOutletIds (action) {
  yield put(actTax.setListTaxes([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds}} = action

  mpLibraryTax.libraryChangeOutlet({currOutlet: outletIds})
  try {
    yield put(actTax.setTaxDetail(null))
    yield call(closeRightColumn)
    yield call(fillFormTaxDetail, {id: null, name: null, amount: null, items: [], custom_amount_flag: false, custom_amount_item: null})
    yield put(act.showProgressBar())
    yield call(apiOutlets.patchLogin, {id: outletIds})
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
    const categoriesRes = yield call(apiCategory.getCategoriesWithUncategorizedV1)
    yield put(actTax.setCategories(categoriesRes.data))
    let res = yield call(apiTax.getTaxService, {page: 0})
    let taxes = res.data.content
    yield put(actTax.setListTaxes(taxes))
    yield put(actTax.setTotalPage(res.data.total_pages))
    yield put(actTax.setCurrentPage(1))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * onClickRowFlow (request) {
  let {payload: {tax}} = request
  try {
    yield put(act.showProgressBar())
    let taxDetail = yield call(apiTax.getTaxDetail, tax.id)
    let res = yield call(apiTax.getTaxItemDetail, tax.id)

    let res1 = yield call(apiTax.getItemCustomAmount, {})
    if (res1.data.length > 0) {
      let tmp = {
        id: res1.data[0].id,
        category_id: res1.data[0].category_id
      }
      taxDetail.data.custom_amount_item = tmp
    } else {
      taxDetail.data.custom_amount_item = null
    }
    let res2 = yield call(apiTax.getTaxItemDetailCustomAmount, tax.id, {}) // for custom amount - TBD
    if (res2.data.length > 0) {
      taxDetail.data.custom_amount_flag = true
    } else {
      taxDetail.data.custom_amount_flag = false
    }

    taxDetail.data.items = res.data.map(item => {
      return {item_id: item.id, category_id: item.category_id, name: item.name}
    })
    taxDetail.data.org_items = taxDetail.data.items.filter(item => true) // set master here... to revert if cancel button pressed on tax form
    taxDetail.data.loaded_items = taxDetail.data.items.filter(item => true) // untouched loaded from file...

    yield put(actTax.setTaxDetail(taxDetail.data))
    yield call(fillFormTaxDetail, taxDetail.data)
    yield put(actTax.taxAssignToItemFillForm({taxDetail: taxDetail.data}))
    // yield put(reset('taxAssignToItem')) // set back as clean - no need
    yield call(openRightColumn)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onClickCancelFlow () {
  yield put(actTax.setTaxDetail(null))
  yield call(fillFormTaxDetail, {id: null, name: null, amount: null, items: [], custom_amount_flag: false, custom_amount_item: null})
  yield put(actTax.taxAssignToItemFillForm({taxDetail: {
    id: null, name: null, amount: null, items: []
  }}))
  // yield put(reset('taxAssignToItem')) // set back as clean - no need to do so
  yield call(closeRightColumn)
}

export function * updateTaxFlow (request) {
  let {payload: {id, data, previousTaxes, itemIds}} = request
  data.item_ids = itemIds

  yield put(act.showProgressBar())
  yield put(actTax.isSubmittingForm(true))
  try {
    if (data.custom_amount_flag === true) {
      data.item_ids.push(data.custom_amount_item.id)
    }

    let response = yield call(apiTax.updateTax, id, data)
    let taxData = response.data
    const taxes = []
    previousTaxes.forEach(tax => {
      if (tax.id === id) {
        taxes.push(taxData)
      } else {
        taxes.push(tax)
      }
    })
    yield put(actNotif.success('Taxes successfully saved.'))
    yield put(actTax.setListTaxes(taxes))
    taxData.items = taxData.items.map(item => {
      return {item_id: item.id, category_id: item.category_id}
    })
    taxData.org_items = taxData.items.filter(item => true)
    taxData.loaded_items = taxData.items.filter(item => true)

    taxData.custom_amount_flag = data.custom_amount_flag
    taxData.custom_amount_item = data.custom_amount_item

    yield put(actTax.setTaxDetail(taxData))
    yield call(fillFormTaxDetail, taxData)
    yield put(actTax.taxAssignToItemFillForm({
      taxDetail: {
        id: taxData.id,
        items: taxData.items
      }
    }))
    // yield put(reset('taxAssignToItem')) // set back as clean
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actTax.isSubmittingForm(false))
  }
}

export function * onClickCreateTaxFlow () {
  yield put(actTax.setTaxDetail({
    id: null,
    name: null,
    amount: null,
    business_id: null,
    outlet_id: null,
    items: [],
    org_items: [],
    loaded_items: [],
    custom_amount_item: null,
    custom_amount_flag: false
  })) // no longer null
  yield call(fillFormTaxDetail, {id: null, name: null, amount: null, items: [], custom_amount_flag: false, custom_amount_item: null})
  yield call(openRightColumn)
}

export function * createTaxFlow (request) {
  let customAmountItem = null
  let {payload: {data, previousTaxes, itemIds, selectedOutletIds, businessId}} = request
  data.item_ids = itemIds
  data.outlet_id = selectedOutletIds // the selected out outlet (it's an array)
  data.business_id = businessId
  data = _.pick(data, ['name', 'amount', 'item_ids', 'outlet_id', 'business_id', 'custom_amount_flag']) // pick out fields required by API
  yield put(act.showProgressBar())
  yield put(actTax.isSubmittingForm(true))
  try {
    if (data.custom_amount_flag === true) {
      let res1 = yield call(apiTax.getItemCustomAmount, {})
      if (res1.data.length > 0) {
        customAmountItem = {
          id: res1.data[0].id,
          category_id: res1.data[0].category_id
        }
        data.item_ids.push(res1.data[0].id)
      }
    }
    let response = yield call(apiTax.createTax, data, businessId)
    let taxData = response.data
    const taxes = [taxData]
    previousTaxes.forEach(tax => {
      taxes.push(tax)
    })
    yield put(actNotif.success('Taxes successfully created.'))
    yield put(actTax.setListTaxes(taxes))
    taxData.items = taxData.items.map(item => {
      return {item_id: item.id, category_id: item.category_id}
    })
    taxData.org_items = taxData.items.filter(item => true)
    taxData.loaded_items = taxData.items.filter(item => true)
    taxData.custom_amount_flag = data.custom_amount_flag
    taxData.custom_amount_item = customAmountItem
    yield put(actTax.setTaxDetail(taxData))
    yield call(fillFormTaxDetail, taxData)
    yield put(actTax.taxAssignToItemFillForm({
      taxDetail: {
        id: taxData.id,
        items: taxData.items
      }
    }))
    // yield put(reset('taxAssignToItem')) // set back as clean
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actTax.isSubmittingForm(false))
  }
}

export function * deleteTaxRequest (request) {
  const {payload: {deletedTax}} = request
  yield put(actTax.setDeletedTax(deletedTax))
  yield put(actTax.showDeleteModal())
}

export function * deleteTaxFlow (request) {
  let {payload: {id, previousTaxes, taxDetail, categories}} = request
  yield put(act.showProgressBar())
  _.forEach(previousTaxes, (prevTax) => { if (id === prevTax.id) mpLibraryTax.libraryDeleteTax({tax: prevTax, taxDetail, categories}) })
  try {
    yield call(apiTax.deleteTax, id)
    const taxes = []
    previousTaxes.forEach((tax) => {
      if (tax.id !== id) {
        taxes.push(tax)
      }
    })
    yield put(actTax.setListTaxes(taxes))
    yield put(actTax.setTaxDetail(null))
    yield put(actTax.setDeletedTax(null))
    yield put(actTax.hideDeleteModal())
    yield call(closeRightColumn)
    yield put(actNotif.success('Taxes successfully deleted.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * cancelDeleteTaxFlow () {
  yield put(actTax.setDeletedTax(null))
  yield put(actTax.hideDeleteModal())
}

export function * createTaxAllOutletsFlow (request) {
  let customAmountItem = null
  let {payload: {data, previousTaxes, itemIds, outlets, selectedOutletIds}} = request
  data.item_ids = itemIds
  data.outlet_id = selectedOutletIds
  data.other_outlet_ids = _.without(_.map(outlets, 'id'), undefined)
  _.pull(data.other_outlet_ids, selectedOutletIds)
  data.business_id = yield select(apiTax.getBusinessId)
  data = _.pick(data, ['name', 'amount', 'item_ids', 'outlet_id', 'business_id', 'other_outlet_ids', 'custom_amount_flag'])
  const numberOfItems = data.item_ids.length // for matching
  yield put(act.showProgressBar())
  yield put(actTax.isSubmittingForm(true))
  try {
    if (data.custom_amount_flag === true) {
      let res1 = yield call(apiTax.getItemCustomAmount, {})
      if (res1.data.length > 0) {
        customAmountItem = {
          id: res1.data[0].id,
          category_id: res1.data[0].category_id
        }
        data.item_ids.push(res1.data[0].id)
      }
    }
    let response = yield call(apiTax.createTaxAllOutlets, data) // START
    let taxData = response.data
    let selectedTaxData = null
    const outletMap = _.keyBy(outlets, 'id')
    let resultForModal = {
      outlet_success: [],
      outlet_failed: []
    }
    taxData.forEach(tax => {
      let outletName = tax.outlet_id
      if (outletMap[tax.outlet_id] !== undefined) {
        outletName = outletMap[tax.outlet_id].name
      }
      if (tax.items.length === numberOfItems) {
        resultForModal.outlet_success.push({ id: tax.outlet_id, name: outletName })
      } else {
        resultForModal.outlet_failed.push({ id: tax.outlet_id, name: outletName })
      }
      if (tax.outlet_id === selectedOutletIds) {
        previousTaxes.push(tax)
        selectedTaxData = tax
      }
    })
    yield put(actNotif.success('Taxes successfully created.'))
    yield put(actTax.setListTaxes(previousTaxes))
    selectedTaxData.items = selectedTaxData.items.map(item => {
      return {item_id: item.id, category_id: item.category_id}
    })
    selectedTaxData.org_items = selectedTaxData.items.filter(item => true)
    selectedTaxData.loaded_items = selectedTaxData.items.filter(item => true)
    selectedTaxData.custom_amount_flag = data.custom_amount_flag
    selectedTaxData.custom_amount_item = customAmountItem
    yield put(actTax.setTaxDetail(selectedTaxData))
    yield call(fillFormTaxDetail, selectedTaxData) // END
    yield put(actTax.taxAssignToItemFillForm({
      taxDetail: {
        id: selectedTaxData.id,
        items: selectedTaxData.items
      }
    }))
    // yield put(reset('taxAssignToItem')) // set back as clean

    if (resultForModal.outlet_success && resultForModal.outlet_success.length > 0) {
      yield put(actTax.setCreatedOutlets({
        outletsFailed: resultForModal.outlet_failed,
        outletsSuccess: resultForModal.outlet_success
      }))
    }
    yield put(actTax.showSaveToAllOutletsModal())
  } catch (error) {
    yield put(actNotif.error(error.message))
    // yield put(actNotif.error('Failed to save tax. There may be one or more conflict in your tax attributes.'))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actTax.isSubmittingForm(false))
  }
}

export default function * saga () {
  yield takeLatest(LIBRARY_TAXES_PAGE_REQUEST, taxesPageRequestFlow)
  yield takeEvery(LIBRARY_TAXES_LIST_REQUEST, taxesRequestFlow)
  yield takeLatest(LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS, onChangeOutletIds)
  yield takeLatest(LIBRARY_TAXES_ON_CLICK_ROW, onClickRowFlow)
  yield takeLatest(LIBRARY_TAXES_ON_CLICK_CANCEL, onClickCancelFlow)
  yield takeLatest(LIBRARY_TAXES_SUBMIT_FORM_UPDATE, updateTaxFlow)
  yield takeLatest(LIBRARY_TAXES_ON_CLICK_CREATE_TAX, onClickCreateTaxFlow)
  yield takeLatest(LIBRARY_TAXES_SUBMIT_FORM_CREATE, createTaxFlow)
  yield takeLatest(LIBRARY_TAXES_DELETE_TAX_REQUEST, deleteTaxRequest)
  yield takeLatest(LIBRARY_TAXES_DELETE_TAX, deleteTaxFlow)
  yield takeLatest(LIBRARY_TAXES_CANCEL_DELETE, cancelDeleteTaxFlow)
  yield takeLatest(LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS, createTaxAllOutletsFlow)

  yield takeLatest(LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM, onClickTaxAssignToItem)
  yield takeLatest(LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM, taxAssignToItemFillFormFlow)
  yield takeLatest(LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM, cancelTaxAssignToItem)
  yield takeLatest(LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM, confirmTaxAssignToItem)
  yield takeLatest(LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST, taxAssignToItemItemsRequest)
  yield takeLatest(LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE, taxAssignToItemSelectAllNone)
  yield takeLatest(LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE, taxAssignToItemToggleOne)
}



// WEBPACK FOOTER //
// ./app/sagas/library/tax.js